



















































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { Job } from '@/models/jobs/job';
import { Facility } from './../../models/jobs/facility';
import JobMainInfo from '@/components/Commons/JobMainInfo.vue';

@Component({
  name: 'LocalJobs',
  components: {
    JobMainInfo,
  },
})
export default class LocalJobs extends Vue {
  private email: string = '';
  private titleMessage = 'Get Notified for similar Jobs';
  private createdJobAlert: boolean = false;
  private jobAlertMessage: string = '';
  $moment: any;
  createJobAlert() {
    this.titleMessage = 'New Job Alert Created!';
    let currentJobDetails = vxm.jobs.AnonymousJobByID;
    this.jobAlertMessage = `New Job Alert request for <b> ${
      currentJobDetails.jobPostingName
    } in ${this.getDefaultFacilityName(
      currentJobDetails.facility,
    )}</b> has been created and
              welcome email has been sent to <b> ${this.email} </b>. You will
              start to receive alerts that match your request.`;
    this.createdJobAlert = true;
  }

  public localjobs: Job[] = [];
  get similarJobs(): Job[] {
    let jobs = vxm.utility.localjobs;
    var utilJobscnt = jobs.length;
    if (localStorage.getItem('localjobs')) {
      this.localjobs = JSON.parse(localStorage.getItem('localjobs') || '[]');
      console.log('local jobs:' + localStorage.localjobs);
    }
    if (utilJobscnt >= this.localjobs.length) return vxm.utility.localjobs;
    else return this.localjobs;

    /*  let jobs = vxm.utility.HistoryLocaljobs;
    console.log('jobs count:'+jobs.length);
    return jobs;*/
  }

  get isLoggedIn() {
    return false;
  }

  get companyCode() {
    return vxm.jobs.BrandingInfo.companycode;
  }

  get referaFriendTitle() {
    return vxm.configs.getGlobalConfigValue('REFER_A_FRIEND_TITLE');
  }

  get referralBannerURL() {
    return `${vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    )}/${vxm.jobs.BrandingInfo.companycode}/CANDIDATEPORTAL/ic_referbanner.png`;
  }

  goTodetailWithTitle(jid: string, jTitle: string, facility: Facility) {
    vxm.jobs.setJobID(parseInt(jid, 10));
    let city = facility.city ? facility.city.trim() : facility.city;
    localStorage.jobviewpage = true;
    let jobTitleSlug = this.jobTitleCitySlug(jTitle, city);
    this.$router.push({
      name: 'findjobs',
    });
    setTimeout(() => {
      this.$router.push({
        name: 'JobdetailsSlug',
        params: { JobID: jid, JobSlug: jobTitleSlug },
      });
    }, 1);
    this.$modal.hide('localjobsmodal');
  }

  jobTitleCitySlug(jTitle: string, city: string): string {
    let slug = '';
    slug = jTitle
      .split(' ')
      .join('-')
      .toLowerCase();
    if (city !== null && city.length > 0) {
      slug = slug.concat('-in-').concat(city.toLowerCase());
    }
    return slug;
  }

  get referFriendLink() {
    if (vxm.users.isLoggedIn) {
      return '/referafriend';
    } else if (vxm.configs.getGlobalConfigBooelanValue('REFERFRIEND_AFTER_LOGIN_ONLY')) {
      return '/login';
    } else {
      return '/anonreferafriend';
    }
  }

  jobStartTime(job: Job): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return job.startImmediately
        ? 'Immediately'
        : this.$moment(job.startDTTM).format(
            vxm.jobs.getCompanyDateFormat.toUpperCase(),
          );
    }
    return job.startImmediately
      ? 'Immediately'
      : this.$moment(job.startDTTM).format('DD-MMM-YYYY');
  }

  get payRateNegotiableText() {
    return vxm.configs.getGlobalConfigValue('NEGOTIABLE_JOB_TEXT');
  }

  getDefaultFacilityName(facility: Facility) {
    let companyCode = vxm.jobs.BrandingInfo.companycode;
    if (
      companyCode &&
      (companyCode.startsWith('EMRLD') ||
        companyCode.startsWith('KNTCARE') ||
        companyCode.startsWith('ALLIED') ||
        companyCode.startsWith('OUTSRC'))
    ) {
      let city = facility.city ? facility.city.trim() : facility.city;
      let state = facility.state ? facility.state.trim() : facility.state;
      return `${city}, ${state}`;
    } else {
      return facility.name;
    }
  }

  getCompanyDistanceUnits(): string {
    if (vxm.jobs.getCompanyDistanceUnit == 'kilometers') {
      return 'km';
    }
    return 'mi';
  }

  jobTypeText(job: Job): string {
    if (job.candidatePlacementTypeText) {
      return job.candidatePlacementTypeText;
    }
    if (job.jobPostingType === '01') {
      return this.$t('Full time').toString();
    }
    if (job.jobPostingType === '02' || job.jobPostingType === '03') {
      if (job.candidatePlacementTypeValue === '00') {
        return this.$t('Full Time Contract Job').toString();
      } else {
        return this.$t('Part Time Contract Job').toString();
      }
    }
    return '';
  }

  getDistance(job: Job) {
    if (job.distance) {
      if (job.distance > 0.1) {
        return job.distance.toFixed(1);
      } else {
        return '< 0.1';
      }
    } else {
      return '0.0';
    }
  }
}
